import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import AppShell from '../components/AppShell';

const HowItWorks = () => (
  <AppShell>
    <SEO
      title="How Summaros works"
      description="A short assessment. A Life Profile. A private space to notice change over time."
      path="/how"
    />
    <section className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-28 animate-fade-up">
      <p className="eyebrow mb-5">How it works</p>
      <h1
        className="display-serif text-4xl sm:text-5xl text-forest mb-8 text-balance"
        style={{ fontVariationSettings: "'opsz' 96, 'SOFT' 50, 'wght' 360" }}
      >
        Small answers. Bigger picture.
      </h1>

      <div className="space-y-10 text-[17px] leading-[1.65] text-ink">
        <div>
          <p className="font-mono text-xs text-clay tracking-widest mb-2">01 · Assessment</p>
          <p>
            A short, chatty walk through the parts of your life:
            body, sleep, food, movement, mind, work, money, relationships,
            habits, environment, growth, and how life feels overall. One
            question at a time. Real answers, not scales.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs text-clay tracking-widest mb-2">02 · Life Profile</p>
          <p>
            Not really a number. More like a sketch of what's going well,
            what's worth watching, and what's quietly connected.
            You'll see states like <em>Strong</em>, <em>Steady</em>,
            <em> Mixed</em>, <em>Worth watching</em>, and <em>Needs attention</em>.
            It's meant to be useful, not judgmental.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs text-clay tracking-widest mb-2">03 · My Life</p>
          <p>
            A quiet, private space of your own. Notice how things are shifting.
            Keep track of what you care about. Add life events as they happen.
            Ask Summaros what it notices.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs text-clay tracking-widest mb-2">04 · Community</p>
          <p>
            A separate world, on purpose. Talk about being human in general.
            Nothing from your private life leaks in.
          </p>
        </div>
      </div>

      <div className="mt-14">
        <Link to="/login?next=/welcome" className="btn-primary">
          Start with me <ArrowRight className="w-4 h-4" strokeWidth={2} />
        </Link>
      </div>
    </section>
  </AppShell>
);

export default HowItWorks;
